import { CAST_AI } from '@cast/constants';
import {
  Button,
  DsShadow,
  Icons,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { SlackIcon } from 'assets/icons';

type Props = {
  onClose: () => void;
  onConnectSlack: () => void;
};

export const SlackBanner = ({ onClose, onConnectSlack }: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: tokens.theme.bg.categorical.indigoStrong,
        boxShadow: ({ shadows }) => shadows[DsShadow.TOOLTIP],
        color: tokens.theme.fg.categorical.onIndigoStrong,
      }}
    >
      <Stack gap={16} p={16}>
        <Stack gap={4}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              variant="h6"
              color={tokens.theme.fg.categorical.onIndigoStrong}
            >
              Never miss a notification
            </Typography>
            <Box
              component="button"
              onClick={onClose}
              sx={{
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 32,
                height: 32,
                color: 'inherit',
              }}
              data-testid="slack-banner-close"
            >
              <Icons.X size={16} />
            </Box>
          </Stack>
          <Typography
            variant="P12M"
            color={tokens.theme.fg.categorical.onIndigoStrong}
          >
            Get notified where your team already works. Connect your workspace
            in a few clicks and receive {CAST_AI} notifications in Slack.
          </Typography>
        </Stack>
        <Button
          variant="secondary"
          size="md"
          onClick={onConnectSlack}
          startIcon={<SlackIcon height={16} width={16} />}
          testId="slack-banner-connect"
        >
          Connect Slack
        </Button>
      </Stack>
    </Box>
  );
};
